import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import AuthCallback from "./components/AuthCallback";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import ServicePage from "./pages/ServicePage";
import { GuideList, ArticlePage } from "./pages/Guide";
import { SERVICE_PAGES } from "./data/services";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/panel" element={<Dashboard />} />
      <Route path="/rehber" element={<GuideList />} />
      <Route path="/rehber/:slug" element={<ArticlePage />} />
      {SERVICE_PAGES.map((s) => (
        <Route key={s.slug} path={`/${s.slug}`} element={<ServicePage slug={s.slug} />} />
      ))}
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors theme="dark" />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
